import { createFileRoute, redirect } from "@tanstack/react-router";

/** An episode used to be addressed under its pod; it has its own address now. */
export const Route = createFileRoute("/_console/production/pods_/$podId/$episodeId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/production/episodes/$episodeId",
      params: { episodeId: params.episodeId },
      replace: true,
    });
  },
});
